import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import UseLocation from '../UseLocation/UseLocation'
import Alert from '@argos/alert'
import './Search.scss'

class Search extends PureComponent {
  render () {
    return (
      <div className='sc-search'>
        <h1 className='sc-search-title' tabIndex='0'>
          Find a store
        </h1>
        <div className={!this.props.showHelpfulLinks ? 'search-block' : 'search-block'}>
          <form className='sc-search-bar hidden-print clearfix' type='search'>
            <input
              className='sc-search-bar-input form-control'
              name='search'
              id='searchbox'
              placeholder='My town or postcode is...'
              autoComplete='off'
            />
            <button className='sc-search-bar-btn btn btn-block' onClick={event => this.props.searchForStores(event)}>
              <span className='sc-search-bar-icon argos-icon icon-UIE-Search' aria-hidden='true' />
              <span className='argos-text sr-only'>Search</span>
            </button>
          </form>
          {!this.props.showHelpfulLinks && (
            <UseLocation smallBtn getLocationFromBrowser={this.props.getLocationFromBrowser} />
          )}
        </div>
        {this.props.searchErrorResponse && (
          <Alert icon='error' backgroundColor='white' borderColor='red' textColor='red' hasBorder hasSVG>
            Oops, we didn't recognise those details. Please try again.
          </Alert>
        )}
        {this.props.showHelpfulLinks && (
          <div className='sc-option-links'>
            <a href='https://www.argos.ie/webapp/wcs/stores/servlet/ArgosStoreLocatorDB?includeName=StoreLocator&langId=111&storeId=10152' className='link pull-left btn-shop-ie' target='_blank'>
              Shop Republic Of Ireland
            </a>
            <a href='#storeslist' onClick={() => this.props.showAZList(true)} className='link pull-right btn-az'>
              <span className='sr-only'>See all stores from </span> A-Z
            </a>
          </div>
        )}
      </div>
    )
  }
}

Search.defaultProps = {
  showHelpfulLinks: true,
  searchErrorResponse: false
}

Search.propTypes = {
  searchForStores: PropTypes.func,
  searchErrorResponse: PropTypes.bool,
  showHelpfulLinks: PropTypes.bool,
  showAZList: PropTypes.func
}

export default Search



// WEBPACK FOOTER //
// ./src/components/Search/Search.jsx